<template>
    <v-dialog v-model="dialogApiPricing" width="800" style="min-width: 470px;">
        <v-card>
            <v-card-title class="headline grey lighten-2">
                {{ apiName }} -&nbsp;<span class="text-capitalize">{{ $t('pricing') }}</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDialog" class="ma-0">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text v-if="apiPricingInformation">
                <div v-if="apiPricingInformation.free">
                    <span class="font-weight-bold free">{{ $t('free') }}</span> &nbsp;&nbsp;
                    <span class="font-weight-bold" style="font-size: 25px; color: #4CA3DD;">
                        {{ formatMoney(apiPricingInformation.free.value, 'number') }}
                    </span>
                    {{ getUnit(apiPricingInformation.free.unit) }}
                    / {{ $t(apiPricingInformation.free.period) }}
                    <span class="ml-3">
                        {{ apiPricingInformation.free.unit === 'Block' ? `( ${$t('block15s')} )` : '' }}
                    </span>
                </div>
                <v-layout row wrap>
                    <v-flex
                        xs12 sm4 md4 lg3 xl3
                        class="ma-1 box-pricing"
                        v-for="(pack, index) in apiPricingInformation.packages"
                        :key="index"
                    >
                        <div class="price-container pa-3">
                            <span>
                                <span v-bind:class="(pack.promotion && pack.promotion!==0) ? 'price_old' : 'price'">{{
                                        formatMoney(pack.value, 'number')
                                    }}</span>
                                {{ getUnit(pack.unit) }}
                            </span>
                            <div class="mt-1" v-if="pack.promotion && pack.promotion!==0">
                                <span class="promotion">{{
                                        formatMoney(pack.value + pack.value * pack.promotion / 100, 'number')
                                    }}</span>
                                {{ getUnit(pack.unit) }}
                            </div>
                        </div>
                        <v-btn class="ma-0 can-buy-pack" depressed color="#4CA3DD" @click="processBuyPackage(pack)">
                            {{ formatMoney(pack.price) }}
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <span>
                    <div>{{ $t('redirectToVNPay') }}</div>
                    <span>
                        {{ $t('contact') }}
                        <a class="px-1" href="mailto:support@fpt.ai">support@fpt.ai</a>
                        {{ $t('toReceiveVATInvoice') }}
                    </span>
                </span>
                <v-spacer></v-spacer>
                <v-btn flat @click="closeDialog">
                    {{ $t('cancel') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import ApiService from '@/services/apis.service'

export default {
    name: 'ApiPricing',
    props: {
        apiCode: String,
        apiName: String,
        apiInformation: null
    },
    computed: {
        ...mapState({
            wallet: state => state.user.wallet
        })
    },
    data () {
        return {
            dialogApiPricing: this.$route.query.pricing === 'on',
            apiPricingInformation: null
        }
    },
    async mounted () {
        if (this.apiCode) {
            await this.getApiInfo()
        }
    },
    methods: {
        getApiInfo () {
            ApiService.getApiPricingInformation(this.apiCode).then(
                result => {
                    this.apiPricingInformation = result.data
                }
            )
        },
        openDialog () {
            this.dialogApiPricing = true
        },
        closeDialog () {
            this.dialogApiPricing = false
        },
        formatMoney (amount, currency = 'VND') {
            try {
                // const negativeSign = amount < 0 ? '-' : ''
                let prefix = currency === 'USD' ? '$' : ''
                let suffix = currency === 'VND' ? '₫' : ''
                let thousands = currency === 'USD' ? ',' : '.'

                let i = parseInt(amount = Math.abs(Number(amount) || 0)).toString()
                let j = (i.length > 3) ? i.length % 3 : 0

                return prefix + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + suffix
            } catch (e) {
                console.log(e)
            }
        },
        processPricingPackage (packageInfo) {
            let countBalance = this.wallet.balance + this.wallet.promotion_balance
            if (countBalance >= packageInfo.price) {
                this.$parent.confirmBuyPacage(packageInfo, this.wallet.balance, this.wallet.promotion_balance)
            } else {
                this.$parent.showToast('Your wallet don\'t have enough money! Please recharge and continue.', 'error')
            }
        },
        classCanBuy (packPrice) {
            let countBalance = this.wallet.balance + this.wallet.promotion_balance
            if (countBalance >= packPrice) {
                return 'ma-0 font-weight-bold can-buy-pack'
            } else {
                return 'ma-0 font-weight-bold cant-buy-pack'
            }
        },
        processBuyPackage (packageInfo) {
            let urlParams = this.getCallBackUrlParams()
            if (urlParams) {
                urlParams = '?' + urlParams
            }
            let urlCallback =
                `${this.$utils.getHostSource()}/payment/verify` +
                `?action=check-order` +
                `&project_id=${this.$route.params.project_id}` +
                `&source=${window.location.pathname}${urlParams}`
            let urlDetail =
                `${this.$utils.getHostSource()}/payment/verify` +
                `?action=cancel-order` +
                `&project_id=${this.$route.params.project_id}` +
                `&source=${window.location.pathname}${urlParams}`
            this.$store.dispatch(this.$actionTypes.LOADING, true)
            ApiService.buyPackage(
                this.$route.params.project_id,
                packageInfo.id,
                urlCallback,
                urlDetail
            ).then(result => {
                if (result.data) {
                    window.location.href = result.data.redirect_url
                }
            }).catch(err => {
                this.$appService.toastError('Cannot create buying request')
                console.log('error: ', err)
            }).finally(() => {
                this.$store.dispatch(this.$actionTypes.LOADING, false)
            })
        },
        getCallBackUrlParams () {
            let paramsStr = ''
            if (this.urlParams) {
                for (let i in this.urlParams) {
                    paramsStr += `${i}=${this.urlParams[i]}%26`
                }
            }
            return paramsStr.length > 0 ? paramsStr.substring(0, paramsStr.length - 3) : paramsStr
        },
        getUnit (unit) {
            unit = this.$t(unit.toLowerCase())
            return this.$appService.getLocale() === 'en' ? unit + 's' : unit
        }
    }
}
</script>

<style scoped lang="scss">
.box-pricing {
    border: 1px solid #4CA3DD;

    .price-container {
        display: grid;
        place-items: center
    }

    .price {
        font-weight: bold;
        font-size: 17px;
        color: #4CA3DD;
    }

    .price_old {
        font-weight: bold;
        font-size: 17px;
        color: #4CA3DD;
        text-decoration-line: line-through;
    }

    .promotion {
        font-weight: bold;
        font-size: 17px;
        color: #d00000;
    }

    &::v-deep .v-btn {
        border-radius: 0;
    }
}

.box-pricing button.can-buy-pack {
    width: 100%;
    color: #FFFFFF;
}

.box-pricing button.cant-buy-pack {
    width: 100%;
    background-color: #f5f5f5 !important;
}

.free {
    font-size: 30px;
    color: #4CA3DD;
    text-transform: uppercase
}
</style>
